<section class="step" aria-labelledby="sb-review-title">
  <!-- The broadcast in one sentence, then what to know before sending -->
  <div class="bk-panel panel review">
    <p class="bk-eyebrow">Review</p>
    <h2 class="review__title" id="sb-review-title" tabindex="-1">
      <strong>{{ formatCount(totals().messages) }}</strong>
      {{ totals().messages === 1 ? "message" : "messages" }} from
      <strong>{{ store.senderIdSig() }}</strong>, using
      <strong>{{ formatCount(totals().parts) }}</strong>
      SMS {{ totals().parts === 1 ? "part" : "parts" }}.
    </h2>

    <dl class="bk-kv review__facts">
      <dt>Name</dt>
      <dd>{{ store.subjectSig() }}</dd>
      <dt>Sheet</dt>
      <!-- No space between a value and its quiet tail: it starts with a comma. -->
      <dd>
        {{ store.fileNameSig() }}@if (store.sheetNames().length > 1 && store.sheetName()) {
          <span class="review__quiet">, sheet “{{ store.sheetName() }}”</span>
        }
      </dd>
      <dt>Numbers from</dt>
      <dd>
        {{ store.phoneLabel() }}<span class="review__quiet">{{ countryNote() }}</span>
      </dd>
      <dt>Upload</dt>
      <dd>
        {{ formatCount(store.upload().rows) }} {{ store.upload().rows === 1 ? "row" : "rows" }}, {{ uploadSize() }}
      </dd>
    </dl>

    <ul class="notes" aria-label="Before you send">
      @for (note of notes(); track $index) {
        <li class="note" [attr.data-tone]="note.tone">
          <span>
            {{ note.text }}
            @if (note.more) {
              <span class="note__more">{{ note.more }}</span>
            }
          </span>
        </li>
      }
    </ul>

    @if (store.error()) {
      <p class="sb-error" role="alert">
        <span class="bk-sym" aria-hidden="true">error</span>
        <span>{{ store.error() }}</span>
      </p>
    }

    <div class="review__actions">
      <button type="button" class="bk-btn bk-btn--ghost" [disabled]="busy()" (click)="back.emit()">
        <span class="bk-sym" aria-hidden="true">arrow_back</span>
        Back
      </button>
      <div class="review__send">
        <button
          type="button"
          class="bk-btn bk-btn--ghost"
          [disabled]="busy() || !testText()"
          (click)="testOpen = true"
        >
          <span class="bk-sym" aria-hidden="true">send_to_mobile</span>
          Send a test
        </button>
        <button
          type="button"
          class="bk-btn bk-btn--primary"
          [attr.aria-disabled]="!canSend || null"
          (click)="askSend()"
        >
          <span class="bk-sym" aria-hidden="true">send</span>
          Send to {{ formatCount(totals().messages) }} {{ totals().messages === 1 ? "number" : "numbers" }}
        </button>
      </div>
    </div>
  </div>

  <!-- Any row, exactly as it goes out -->
  <div #previewPanel class="bk-panel panel review__preview">
    <sb-row-preview heading="What each person gets" />
    @if (totals().maxParts > 1 && totals().longest >= 0) {
      <button type="button" class="bk-more review__longest" (click)="showLongest()">
        Show the longest message ({{ totals().maxParts }} parts)
        <span class="bk-sym" aria-hidden="true">arrow_forward</span>
      </button>
    }
  </div>

  <sb-rows-to-check (preview)="previewRow($event)" />
</section>

<app-prompt-card
  [openModal]="confirmOpen"
  [title]="'Send ' + formatCount(totals().messages) + (totals().messages === 1 ? ' message now?' : ' messages now?')"
  buttonText="Send now"
  closeText="Not yet"
  tone="default"
  impactIcon="send"
  [impact]="impact"
  [loading]="busy()"
  (onClose)="closeConfirm()"
  (onButtonClick)="send()"
>
  <p class="review__confirm">
    Each row gets its own message, named “{{ store.subjectSig().trim() }}”. You can follow progress on the next
    screen.
  </p>
</app-prompt-card>

<app-send-test-message-modal
  [openModal]="testOpen"
  [messageBody]="testText()"
  [senderId]="store.senderIdSig()"
  (closeModalEvent)="testOpen = false"
/>
